import { render, staticRenderFns } from "./AddBubbleWidget2.vue?vue&type=template&id=ddd0d2e4&"
import script from "./AddBubbleWidget2.vue?vue&type=script&lang=js&"
export * from "./AddBubbleWidget2.vue?vue&type=script&lang=js&"
import style0 from "./AddBubbleWidget2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports